export const calculatePoints = ({ price, multiplier }: { price: number; multiplier: number }) =>
    Math.round(multiplier * price);
